var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8001 19.5195C27.597 19.8844 26.3207 20.0806 24.9985 20.0806C17.7745 20.0806 11.9182 14.2244 11.9182 7.00036C11.9182 5.67873 12.1143 4.40289 12.4788 3.20032C7.10887 4.82883 3.2002 9.81771 3.2002 15.7195C3.2002 22.9435 9.05641 28.7997 16.2804 28.7997C22.1828 28.7997 27.1721 24.8903 28.8001 19.5195Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkon);
export default __webpack_public_path__ + "static/media/darkon.8efb3218c3adcde84664ba8285519efd.svg";
export { ForwardRef as ReactComponent };